import axios from 'axios';
import Vue from 'vue';
import router from '../router'
import store from '../state/store';

let requestsPending = 0;

/**
 * Apply interceptor on request
 */
axios.interceptors.request.use((config) => {
        store.dispatch('app/initRoutesNotLoading');

        requestsPending++;
        config.baseURL = process.env.VUE_APP_URL;
        config.headers.Platform = process.env.VUE_APP_PLATFORM;

        const user = store.state.auth.currentUser;
        const routesNotLoading = store.state.app.routesNoLoading;

        if (routesNotLoading.findIndex(endpoint => config.url.includes(endpoint)) == -1) {
            store.dispatch('app/setAppAsLoading');
        }

        if (user && user.token) {
            config.headers.Authorization = `Bearer ${user.token}`;
        }
        return config;

    }, (error) => {
        return Promise.reject(error);
    }
);

/**
 * Apply interceptor on response
 */
axios.interceptors.response.use((response) => {
        requestsPending--;

        if (requestsPending <= 0) {
            store.dispatch('app/setAppAsReady');
        }

        if (response.status === 200 && response.data.message) {
            Vue.swal(response.data.title ? response.data.title : 'Success', response.data.message, 'success');
        }
        /*
        if (response.status === 200 && response.data.message) {
            toast.success(response.data.message)
        }
        if (response.status === 201 && response.data.message) {
            toast.success(response.data.message)
        }
         */
        return response
    }, (error) => {
        requestsPending--;

        if (requestsPending <= 0) {
            store.dispatch('app/setAppAsReady');
        }

        switch (error.response.status) {
            case 401:
                if(store.state.auth.currentUser !== null && store.state.auth.currentUser.id !== null){
                    store.commit('auth/SET_CURRENT_USER', null);
                    router.push("login").catch(()=>{});
                }
                break;
            case 403:
                router.push({name: '403'});
                break;
            case 503:
                /*store.dispatch('auth/clearAuthState');
                store.dispatch('menu/clearMenuState');*/
                router.push({name: 'maintenance'});
                break;
            default:
                if (error.response.data.message && error.response.status !== 401) {
                    let message = error.response.data.message;
                    message += '<ul style="text-align: left">';

                    if (error.response && error.response.data.errors) {
                        for (let key in error.response.data.errors) {
                            message += '<li>' + error.response.data.errors[key][0] + "</li>";
                        }
                        message += "</ul>";
                    } else {
                        message = error.response.data.message;
                    }

                    Vue.swal('Error', message, 'error');
                }
                break;

        }
        return Promise.reject(error)
    }
);
